import styled from 'styled-components';
import { device } from '../../utils/styled-component-mixins';

const AccountFormStyled = styled.div`
  display: flex;
  flex-direction: column;

  .form {
    margin: 8rem auto;
    padding: 3rem;
    box-shadow: var(--card-shadow);
    width: 70rem;

    @media ${device.deviceOnly} {
      width: auto;
      margin: 4rem 1rem;
    }
  }

  .form-field {
    display: flex;
    width: 100%;
    margin-top: 2rem;

    &-no-margin-top {
      margin-top: 0;
    }

    > div {
      width: 100%;
    }

    &.account-links {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }

  .error-message {
    color: var(--bdo-red);
  }

  .thank-you {
    p {
      font-size: 2.25rem;
    }

    width: 100%;
    margin: 3rem auto;
  }

  .btn {
    border: none;
    width: 100%;
  }
`;

const AccountForm = (props) => (
  <AccountFormStyled>
    <div className="form">
      {props.heading && <h1 className="form-heading">{props?.heading}</h1>}
      {props?.children}
      {props.errorMessage && (
        <div className="form-field">
          <p className="error-message">{props.errorMessage}</p>
        </div>
      )}
      {props.message && (
        <div className="form-field">
          <p className="error-message">{props.message}</p>
        </div>
      )}
      {props.useDefaultSubmit && props?.submitText && (
        <div className="form-field">
          <button
            data-sitekey="test"
            className="btn btn-primary submit"
            type="submit"
            onClick={props?.handleSubmit}
            {...props}
          >
            {props?.submitText}
          </button>
        </div>
      )}
      {props?.afterSubmit}
    </div>
  </AccountFormStyled>
);

export default AccountForm;
